<template>
    <div>
        <template v-if="value.side == EMPLOYMENT_FIELD_SIDES.DOCUMENT.value">
            {{ value?.data?.toDate?.() }}
        </template>
        <template v-else>
            <template v-if="false"></template>
            <template v-else-if="mode == 'done'">
                {{ value?.data?.toDate?.() }}
            </template>
            <template v-else-if="mode == 'sign'">
                <node-edit v-bind="{ value, width: 240 }" v-on="{ sync, emit }" v-slot="{ save }">
                    <v-text-field v-model="form.data" type="date" clearable autofocus @keydown.enter.prevent="save" />
                </node-edit>
            </template>
            <template v-else>
                <span style="opacity: 0.5; word-break: auto-phrase;">
                    {{ value.term }}
                </span>
            </template>
        </template>
    </div>
</template>

<script>
import { EMPLOYMENT_FIELD_SIDES, initEmploymentField } from "@/assets/variables";

import NodeEdit from "./node-edit.vue";

export default {
    components: {
        NodeEdit,
    },
    props: {
        value: { type: Object, default: initEmploymentField },

        /** @type {import('vue').PropType<'form'|'sign'|'view'|'done''>} */
        mode: { type: String, default: "form" },
    },
    data: () => ({
        form: initEmploymentField(),

        EMPLOYMENT_FIELD_SIDES,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentField(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style></style>
